import { attributes } from "./constants";
export default function deserializeCaches({ query, total, page, per_page, count, caches }) {
  var _a;
  return {
    attributes,
    list: (_a = caches.map((cache) => ({ ...cache, id: cache.id }))) != null ? _a : [],
    pagination: { total, page, per_page, count, query }
  };
}
